import { OptimizelyProvider as OptimizelyProviderDefault } from '@optimizely/react-sdk';
import React, { useState } from 'react';
import initOptimizely from 'src/utils/initOptimizely';
import { v4 as uuidv4 } from 'uuid';

import { OPTIMIZELY_USER_ID_STORAGE_KEY } from './constants';

const optimizelyInstance = initOptimizely();

export function getUserAttributes(id: string | null) {
  return {
    internalStaff: id ? id?.toLowerCase().endsWith('ovo.com') : false,
  };
}

export function getInitialUser() {
  if (typeof window === 'undefined') {
    return { id: 'unknown', attributes: getUserAttributes(null) };
  }
  let storedId = localStorage.getItem(OPTIMIZELY_USER_ID_STORAGE_KEY);
  if (!storedId) {
    storedId = uuidv4();
    localStorage.setItem(OPTIMIZELY_USER_ID_STORAGE_KEY, storedId);
  }
  return { id: storedId, attributes: getUserAttributes(storedId) };
}

const OptimizelyProvider = ({ children }: { children: React.ReactNode }) => {
  const [user] = useState(getInitialUser); // never changes after mount
  return (
    <OptimizelyProviderDefault optimizely={optimizelyInstance} user={user} timeout={30}>
      {children}
    </OptimizelyProviderDefault>
  );
};

export default OptimizelyProvider;
